import { ASSIGNMENT_PLATFORMS, AssignmentPlatform } from "refsix-core";

/**
 * Which scraped-platform tiles a user should see (REFSIX-568).
 *
 * Nothing about the user comes into it: these platforms are scraped from the
 * referee's own browser session, so there is no partner entitlement to hold and
 * no plan to buy. Every launched platform is shown to everyone.
 *
 * `launched` used to be a dogfooding gate — unlaunched platforms were visible
 * only under developer tools. It is now a kill switch, and that is the reason to
 * keep it: withdrawing a platform after a store release (a scrape that breaks, a
 * platform that objects) otherwise needs a build, and a build needs review. A
 * flag we can flip in a deploy is the only fast way out.
 *
 * A platform that has not launched is hidden rather than teased, as the app
 * already does for unreleased integrations (see the Stack Officials tile).
 *
 * Pure on purpose — the decision is worth a unit test rather than only Cypress
 * coverage.
 */
export function visibleAssignmentPlatforms(
    platforms: AssignmentPlatform[] = ASSIGNMENT_PLATFORMS
): AssignmentPlatform[] {
    return platforms.filter((platform) => platform.launched);
}
